import type { MigrationFormPayloadType } from "@/react/types/PaywallAccessGroupMigration";

import { absolutePath } from "../../../absolutePath";

export const accessGroupsMigration = {
  preview: (params: MigrationFormPayloadType) =>
    absolutePath(`admin/paywalls/access_group_migrations/preview`, params),
  create: (params: MigrationFormPayloadType) =>
    absolutePath(`admin/paywalls/access_group_migrations`, params),
};
